import { render, staticRenderFns } from "./ClientsPane.vue?vue&type=template&id=70a01860"
import script from "./ClientsPane.vue?vue&type=script&lang=ts"
export * from "./ClientsPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports